<template>
  <div v-if="song_id">
    <CommentEntityWrapper :entity-id="song_id" :toggle-class="'songComments'" :fk_property="'song'" :slice-comments="10" :comment-points="user ? points : 0" />
  </div>
</template>

<script>
import CommentEntityWrapper from "../Comment/CommentEntityWrapper.vue";

export default {
  name: "SongComments",
  inject: ['user'],
  components: { CommentEntityWrapper },
  data() {
    return {
      song_id: null,
      points: 0,
    }
  },
  mounted() {
    this.song_id = this.$el.parentNode.getAttribute('data-vue-song-comments');
    this.points = parseInt(this.$el.parentNode.getAttribute('data-vue-points'));
  }
}
</script>
